import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@entities/User';
import { trackEvent } from '@shared/analytics';
import { buildComposerState, paths } from '@shared/config';
import { cn } from '@shared/lib';
import { PlusIcon } from '@shared/ui';

/**
 * «Создать свою карточку» — вторая кнопка под «Тренироваться» (владелец 2026-11-03: «это должно быть заметнее для тех,
 * кто пришёл создавать карточки свои и учить… или под тренироваться вторую кнопку создать свою карточку»): к строке
 * создания на «Словах и модулях». Почта не подтверждена и бесплатная карточка потрачена — кнопки нет (о почте просит
 * плашка вверху главной).
 */
export function useCreateLocked() {
  return useAuthStore((s) => !!s.user && !s.user.emailVerified && !s.user.guestCardAvailable);
}

export function CreateCardButton({ phone }: { phone: boolean }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const locked = useCreateLocked();
  if (locked) return null;
  return (
    <button
      type="button"
      onClick={() => {
        trackEvent('home_create_clicked', { action: 'card' });
        navigate(paths.words, { state: buildComposerState() });
      }}
      className={cn(
        'flex flex-none items-center justify-center gap-2.5 whitespace-nowrap rounded-pill border border-solid border-[#4a4a52] font-semibold text-fg transition-colors hover:border-accent hover:text-[#ff8236] focus-visible:outline-none focus-visible:shadow-[0_0_0_3px_rgba(243,106,28,.5)]',
        phone ? 'h-12 w-full text-[16px]' : 'h-[48px] px-7 text-[15px]',
      )}
    >
      <PlusIcon className="h-4 w-4 flex-none" aria-hidden />
      {t('dashboard.home.createRow.button')}
    </button>
  );
}
